export default __webpack_public_path__ + "static/media/img-slider-banpu-2.60dd1c14.png";